
export default function Home(){
    return (
        <div>
            <h1>
                Estamos en Home
            </h1>
        </div>
    );
}